export function isInputElement(element: Element | null): element is HTMLInputElement {
  return element?.nodeName === 'INPUT';
}
